import { ArrowRight, ArrowUpRight } from "untitledui-js/react";
import { twMerge } from "tailwind-merge";

const SIZE_VARIANTS = {
  sm: 10,
  lg: 24,
};

interface HoverArrowProps {
  variant?: keyof typeof SIZE_VARIANTS;
  className?: string;
  isHiddenSmallScreen?: boolean;
}

export const HoverArrow = ({
  className,
  variant = "lg",
  isHiddenSmallScreen = false,
}: HoverArrowProps) => {
  return (
    <div
      className={twMerge(
        "flex items-center justify-center rounded-full bg-white/50 *:stroke-secondary-950 group-hover:bg-primary-500",
        variant === "lg" ? "p-2.5" : "h-6 w-6",
        isHiddenSmallScreen ? "hidden" : "flex",
        className
      )}
    >
      <ArrowUpRight
        className="flex-shrink-0 group-hover:hidden"
        data-testid="arrow-up-right"
        width={SIZE_VARIANTS[variant]}
        height={SIZE_VARIANTS[variant]}
      />
      <ArrowRight
        className="hidden flex-shrink-0 group-hover:block"
        data-testid="arrow-right"
        width={SIZE_VARIANTS[variant]}
        height={SIZE_VARIANTS[variant]}
      />
    </div>
  );
};
